// Mock data for frontend-first design phase.
// Swap each export for Supabase queries when backend is wired.

export const SERVICES = [
  // Phase 1 — Foundation
  { code: "p1_website", phase: 1, name: "Foundation Website", summary: "Fast, trust-building 5–7 page site with lead capture.", effort: 3 },
  { code: "p1_seo_local", phase: 1, name: "Local SEO", summary: "GBP, citations, on-page, local landing pages.", effort: 2 },
  { code: "p1_aeo", phase: 1, name: "Answer Engine Optimization", summary: "Schema, FAQ, AI-answer readiness (ChatGPT / Perplexity).", effort: 2 },
  { code: "p1_reputation", phase: 1, name: "Reputation Core", summary: "Review velocity engine, response playbooks, testimonials.", effort: 2 },
  // Phase 2 — Growth (gated by BSS ≥ 75)
  { code: "p2_website_advanced", phase: 2, name: "Advanced Website", summary: "Conversion systems, A/B, personalization, booking funnels.", effort: 3 },
  { code: "p2_seo_regional", phase: 2, name: "Regional / National SEO", summary: "Topical authority, link velocity, cluster strategy.", effort: 3 },
  { code: "p2_brand_reputation", phase: 2, name: "Brand Reputation", summary: "Narrative control, PR, thought leadership.", effort: 3 },
  { code: "p2_ads_search", phase: 2, name: "Search Ads", summary: "Google / Bing intent capture with ROI telemetry.", effort: 3 },
  { code: "p2_ads_social", phase: 2, name: "Social Ads", summary: "Meta / TikTok demand gen + retargeting.", effort: 3 },
  { code: "p2_content_engine", phase: 2, name: "Content Engine", summary: "Single / bulk / scheduled generator with brand voice.", effort: 3 },
  // Phase 3 — Retention
  { code: "p3_retention_email", phase: 3, name: "Retention Email", summary: "Lifecycle, win-back, nurture sequences.", effort: 2 },
  { code: "p3_referral_program", phase: 3, name: "Referral Program", summary: "Incentive system, tracking, reward automation.", effort: 2 },
  { code: "p3_upsell_campaigns", phase: 3, name: "Upsell Campaigns", summary: "Customer-base campaigns with offer logic.", effort: 2 },
  { code: "p3_client_success", phase: 3, name: "Client Success", summary: "NPS, health score, QBR cadence.", effort: 2 },
];

export const CLIENTS = [
  { id: "c1", name: "Harbor Dental", industry: "Healthcare", bss: 82, stage: 7, directive: "lead_gen", status: "Phase 2 — live", cpl: 38, trend: "+12%" },
  { id: "c2", name: "Ember HVAC", industry: "Home Services", bss: 68, stage: 5, directive: "lead_gen", status: "Trust Sprint", cpl: 64, trend: "-4%" },
  { id: "c3", name: "Loom Legal", industry: "Professional", bss: 74, stage: 6, directive: "hybrid", status: "Approaching gate", cpl: null, trend: "n/a" },
  { id: "c4", name: "Northwind Realty", industry: "Real Estate", bss: 91, stage: 9, directive: "lead_gen", status: "Phase 2 — scaling", cpl: 28, trend: "+21%" },
  { id: "c5", name: "Verdant Café", industry: "Hospitality", bss: 55, stage: 3, directive: "brand_awareness_only", status: "Foundation", cpl: null, trend: "n/a" },
];

export const SPARK_STAGES = [
  { n: 1, name: "Intake & Primary Directive", active: true },
  { n: 2, name: "Market & ICP", active: true },
  { n: 3, name: "Positioning & USP", active: true },
  { n: 4, name: "Brand Voice & Pillars", active: true },
  { n: 5, name: "Trust Architecture", active: true },
  { n: 6, name: "Offer & Funnel Mapping", active: false },
  { n: 7, name: "SEO / AEO Blueprint", active: false },
  { n: 8, name: "Sitemap & Wireframe", active: false },
  { n: 9, name: "Content Engine Setup", active: false },
  { n: 10, name: "Launch & Measurement", active: false },
  { n: 11, name: "Growth & ROI Loop", active: false },
];

export const BSS_BREAKDOWN = [
  { category: "Reviews & Reputation", score: 82, weight: 0.25 },
  { category: "Website & Conversion", score: 78, weight: 0.20 },
  { category: "Visibility (SEO/AEO)", score: 71, weight: 0.20 },
  { category: "Content Consistency", score: 65, weight: 0.15 },
  { category: "Trust Signals", score: 88, weight: 0.10 },
  { category: "Offer Clarity", score: 80, weight: 0.10 },
];

export const ROI_SUMMARY = {
  totalSpend: 184200,
  totalRevenue: 1_462_800,
  roas: 7.94,
  leads: 2341,
  avgCPL: 78.68,
  closedWon: 412,
};

export const KPIS = [
  { label: "Active Clients", value: "27", delta: "+4 QoQ" },
  { label: "Avg BSS", value: "74", delta: "+6 pts" },
  { label: "Phase-2 Gated", value: "18", delta: "67%" },
  { label: "Avg CPL", value: "$48", delta: "-18%" },
  { label: "ROAS (blended)", value: "7.9x", delta: "+1.2" },
  { label: "NPS", value: "71", delta: "+9" },
];
